<template>

  <div
    class="modalo adapted-meet-max-width">
    
    <div 
      class="modalo-backgroud adapted-meet-max-width"
      @click="hideModal()"
      :style="{'background': this.modaloAlert ? 'rgba(0,0,0,0.65)' : 'rgba(0,0,0,0.5)'}"></div>

    <div 
      class="modalo-main" 
      :class="typeClass">
      
      <div class="modalo-actions">
        <button
          type="button"
          @click="hideModal()"
          class="btn btn-dark"><i class="fa-solid fa-xmark"></i></button>
        <button 
          v-if="showNext || showPrevious"
          :disabled="!showNext"
          @click="next()" 
          class="btn btn-dark"> <i class="fa-solid fa-chevron-right"></i> </button>
        <button
          v-if="showNext || showPrevious"
          :disabled="!showPrevious"
          @click="previous()" 
          class="btn btn-dark"> <i class="fa-solid fa-chevron-left"></i> </button>
      </div>

      <div class="modalo-container">
        <creating
          v-if="creating">
          </creating>
        
        <template
          v-if="!creating">
          <div 
            class="modalo-header" 
            v-if="title">
            <h4>{{ title }}</h4>
            </div>
            <!--end modalo-header-->

          <div 
            class="modalo-header" 
            v-if="$slots.header">
            <slot name="header"></slot>
            </div>
            <!--end modalo-header-->

          <div
            class="modalo-content"
            :style="{'padding': padding}">
            <slot></slot>
          </div>
          <!--end modalo-content-->

          <div 
            class="modalo-footer" 
            v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
          <!--end modalo-footer-->
        </template>

      </div>
      <!--end modalo-container-->

    </div>
    <!--end modalo-main-->

  </div>
  <!--end modalo-->

</template>

<script>
export default {
  name: 'Modalo',
  components: {
  },
  props: {
    'title': {
      type: String,
      default: ''
    },
    'type': {
      type: String,
      default: 'long'
    },
    'padding': {
      type: String,
      default: '1.5em 2em'
    },
    'creating': {
      type: Boolean,
      default: false
    },
    'showNext': {
      type: Boolean,
      default: false
    },
    'showPrevious': {
      type: Boolean,
      default: false
    },
    'modaloWatch': {
      type: Function
    }
  },
  data () {
    return {
      modaloId: `modalo-${Math.floor(Math.random() * 10000)}`
    }
  },
  created () {
    document.body.style.overflow = 'hidden'
    this.$store.dispatch('setModalo', this.modaloId)
  },
  mounted () {
    // start modaloWatch if is set
    if (this.modaloWatch) {
      setTimeout(() => {
        this.$watch(this.modaloWatch, {
          deep: true,
          handler: () => {
            this.$store.dispatch('changeLastModalo')
          }
        })
      }, 100)
    }
  },
  computed: {
    typeClass () {
      return {
        medium: 'modalo-medium',
        small: 'modalo-small',
        mini: 'modalo-mini'
      }[this.type]
    },
    modaloAlert () {
      const modalos = this.$store.getters.getModalo
      const item = modalos.find(item => item.id === this.modaloId)
      return item ? item.alert : false
    }
  },
  destroyed () {
    document.body.style.overflow = 'auto'
    this.$store.dispatch('removeModalo', this.modaloId)
  },
  methods: {
    /*
    hideModal
    */
    hideModal () {
      if (this.modaloAlert) {
        this.$store
        .dispatch('setAlertModal', {
          title: 'Descartar alterações?',
          message: 'Você tem alterações não salvas que serão perdidas.',
          action: () => { return this.$emit('hideModal') }
        })
      } else {
        this.$emit('hideModal')
      }
    },
    next () {
      this.$emit('next')
    },
    previous () {
      this.$emit('previous')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalo{
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  padding: 0 0 0 60px;
}
  .modalo-backgroud{  
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
  }
  .modalo-main{
    background: #ffffff;
    max-width: 1250px;
    margin: 0 0 0 auto;
    position: relative;
    z-index: 2;
    height: 100%;
  }
    .modalo-main.modalo-medium{
      max-width: 800px;
    }
    .modalo-main.modalo-small{
      max-width: 640px;
    }
    .modalo-main.modalo-mini{
      max-width: 500px;
    }
    .modalo .modalo-actions {
      position: absolute;
      z-index: 3;
      width: 40px;
      left: -43px;
      top: 15px;
    }
    .modalo .modalo-actions button {
      position: block;
      width: 40px;
      height: 40px;
      border-radius: 35px;
      padding: 0;
      margin: 0 0 3px 0;
      text-align: center;
      font-size: 16px;
    }
    .modalo-container{
      height: 100%;
      display: flex;
      flex-direction: column;
    }
      .modalo-header{
        flex: 0;
        padding: 1.5em 2em;
        border-bottom: 1px solid #ebebeb;
      }
        .modalo-header > h4{
          margin: 0;
        }
      .modalo-content {
        flex: 1;
        overflow: auto;
      }
      .modalo-footer{
        flex: 0;
        padding: 1.5em 1.5em;
        border-top: 1px solid #ebebeb;
      }
</style>



// WEBPACK FOOTER //
// src/components/Modalo/Modalo.vue